// The five provider connection kinds — GOALS/GOALS-MODEL-PROVIDER-MANAGEMENT.md
// ("There are five, not four", 2026-09-03) — as contract vocabulary. The
// World authority (backend/convex/lib/providerConnectionLaw.js) owns the same
// five literals; this list exists so no surface hand-writes a column.
// Titles are display labels, never identity (DL1).

export const PROVIDER_CONNECTION_KINDS = [
  "neucleos-managed-api",
  "world-managed-api",
  "actor-byok",
  "actor-byo-subscription",
  "neucleos-managed-subscription-seat",
] as const;
export type ProviderConnectionKind = (typeof PROVIDER_CONNECTION_KINDS)[number];

export const PROVIDER_CONNECTION_KIND_TITLES: Readonly<Record<ProviderConnectionKind, string>> = {
  "neucleos-managed-api": "Neucleos API",
  "world-managed-api": "World API",
  "actor-byok": "BYO key",
  "actor-byo-subscription": "BYO subscription",
  "neucleos-managed-subscription-seat": "Managed seat",
};

export const PROVIDER_CONNECTION_KIND_SUMMARIES: Readonly<Record<ProviderConnectionKind, string>> =
  {
    "neucleos-managed-api":
      "Neucleos owns and pays for the provider credential; calls run through the Neucleos gateway and bill the World.",
    "world-managed-api":
      "The World owns and pays for its own provider account and credential; that spend never becomes Neucleos provider cost.",
    "actor-byok":
      "The member owns, pays for, and connects their own API credential; authority and usage stay scoped to them in this World.",
    "actor-byo-subscription":
      "The member owns and pays for a provider subscription and signs in through the provider's own native path; Neucleos owns neither the seat nor its credentials.",
    "neucleos-managed-subscription-seat":
      "Neucleos purchases and administers one provider Enterprise seat for one named, continuing customer; never shared, pooled, or resold.",
  };

export const isProviderConnectionKind = (value: unknown): value is ProviderConnectionKind =>
  typeof value === "string" && (PROVIDER_CONNECTION_KINDS as ReadonlyArray<string>).includes(value);

// SB-CAN-12 (register §35, D-SB6): the dedicated capability the Commercial
// Operations board is gated on — seated by ceremony in the two Neucleos
// Worlds, absent from every provisioning list, never world.manage.
export const COMMERCE_OPERATIONS_CAPABILITY = "commerce.operate";
